'use client';

import Error from '@/app/error';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  return (
    <html>
      <body>
        <Error error={error} />
      </body>
    </html>
  );
}
